import { useEffect, useState } from 'react';
import { Link } from 'react-router';

type TimeLeft = {
  days: number;
  hours: number;
  minutes: number;
};

// Helper to get a Date object representing a Cairo time in the user's local timezone
function getCairoDate(year: number, month: number, day: number, hours: number, minutes: number) {
  // month is 0-based for Date, so month param should be 0-11
  const utcMillis = Date.UTC(year, month, day, hours, minutes);

  // Africa/Cairo IANA timezone; fall back to UTC if unavailable
  const cairoFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Africa/Cairo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  const parts = cairoFormatter.formatToParts(utcMillis).reduce(
    (acc, part) => {
      if (part.type !== 'literal') {
        acc[part.type] = part.value;
      }
      return acc;
    },
    {} as Record<string, string>
  );

  const localDate = new Date(
    Number(parts.year),
    Number(parts.month) - 1,
    Number(parts.day),
    Number(parts.hour),
    Number(parts.minute),
    0,
    0
  );

  return localDate;
}

const startDate = getCairoDate(2025, 10, 16, 0, 0); // Nov 17, 2025 00:00 (Cairo)
const endDate = getCairoDate(2025, 10, 30, 10, 0); // Nov 23, 2025 10:00 (Cairo)

function calculateTimeLeft(target: Date): TimeLeft {
  const now = new Date().getTime();
  const difference = target.getTime() - now;

  if (difference <= 0) {
    return { days: 0, hours: 0, minutes: 0 };
  }

  const days = Math.floor(difference / (1000 * 60 * 60 * 24));
  const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((difference / (1000 * 60)) % 60);

  return { days, hours, minutes };
}

export default function AnnouncementBar() {
  const [isActive, setIsActive] = useState(false);
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(() => calculateTimeLeft(endDate));

  useEffect(() => {
    const checkActive = () => {
      const now = new Date();
      setIsActive(now >= startDate && now <= endDate);
    };

    checkActive();

    const interval = setInterval(() => {
      checkActive();
      setTimeLeft(calculateTimeLeft(endDate));
    }, 60 * 1000); // update every minute

    return () => clearInterval(interval);
  }, []);

  if (!isActive) return null;

  return (
    <div className="fixed top-0 right-0 left-0 z-50 flex w-full items-center justify-center bg-[#0C0C0C] px-3 py-2 text-xs text-white sm:px-4 md:text-sm">
      {/* <div className="flex flex-col items-center gap-1 md:flex-row md:gap-4">
        <span className="font-medium tracking-wide">Black Friday Offer Coming Soon</span>
        <div className="flex items-center gap-3 text-[10px] font-semibold md:text-xs">
          <div className="flex items-baseline gap-1">
            <span className="text-base md:text-lg">
              {timeLeft.days.toString().padStart(2, '0')}
            </span>
            <span className="opacity-80">DAYS</span>
          </div>
          <span className="opacity-60">•</span>
          <div className="flex items-baseline gap-1">
            <span className="text-base md:text-lg">
              {timeLeft.hours.toString().padStart(2, '0')}
            </span>
            <span className="opacity-80">HRS</span>
          </div>
          <span className="opacity-60">•</span>
          <div className="flex items-baseline gap-1">
            <span className="text-base md:text-lg">
              {timeLeft.minutes.toString().padStart(2, '0')}
            </span>
            <span className="opacity-80">MINS</span>
          </div>
        </div>
      </div> */}

      <div className="flex flex-col items-center gap-2 md:flex-row md:gap-4">
        <span className="text-center text-sm font-medium tracking-wide md:text-base lg:text-lg">
          Black Friday Offer: Get 50% OFF on all plans
        </span>
        <div className="flex items-center gap-3">
          <Link
            to="/pricing"
            className="text-xs font-semibold text-[#FFC022] uppercase hover:text-[#FFC022]/80 md:text-sm lg:text-base"
          >
            claim now
          </Link>
        </div>
      </div>
    </div>
  );
}
